"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = find;

var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));

var _findIndex = _interopRequireDefault(require("./findIndex.js"));

var _findKey = _interopRequireDefault(require("./findKey.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Return the first value which passes a truth test.
function find(obj, predicate, context) {
  var keyFinder = (0, _isArrayLike.default)(obj) ? _findIndex.default : _findKey.default;
  var key = keyFinder(obj, predicate, context);
  if (key !== void 0 && key !== -1) return obj[key];
}